import ddt from '@wix/da-ddt';
import { getCookiePrivacyRequired, getCookieSettings, getHasAcceptedCookies } from '../../publicSession/selectors';
import { setCompliantLocalStorageItem, removeCompliantLocalStorageItem } from './actions';
import { verifyAccessToLocalStorage, getStorageEventChannel } from './utils';
import { takeEvery, all, select } from 'redux-saga/effects';
import localStorageWrapper from '../../utils/localStorageWrapper';
import { appMounted } from '../../redux/app/actions';
export function* setCompliantLocalStorageHandler(action) {
    if (verifyAccessToLocalStorage(action.payload.key, (yield select(getCookiePrivacyRequired)), (yield select(getHasAcceptedCookies)), (yield select(getCookieSettings)))) {
        ddt.log('compliantlocalstorage', `writing key: ${action.payload.key} to localStorage with value of: ${action.payload.value}`);
        localStorageWrapper.setItem(action.payload.key, action.payload.value || '');
    }
}
export function* appMountedHandler() {
    const handler = (event)=>{
        try {
            getStorageEventChannel().put(event);
        } catch (e) {
            ddt.log('compliantlocalstorage', 'Error from channel', event, e);
        }
    };
    window.addEventListener('storage', handler);
    return ()=>{
        window.removeEventListener('storage', handler);
    };
}
function* removeCompliantLocalStorageHandler(action) {
    const { key  } = action.payload;
    if (verifyAccessToLocalStorage(key, (yield select(getCookiePrivacyRequired)), (yield select(getHasAcceptedCookies)), (yield select(getCookieSettings)))) {
        ddt.log('compliantlocalstorage', `removing key: ${key}`);
        localStorageWrapper.removeItem(key);
    }
}
export default function* saga() {
    yield all([
        takeEvery(appMounted, appMountedHandler),
        takeEvery(setCompliantLocalStorageItem, setCompliantLocalStorageHandler),
        takeEvery(removeCompliantLocalStorageItem, removeCompliantLocalStorageHandler)
    ]);
}
